<search-service-centers [assignedOnly]=true [showSearch]=false [showAddNew]="false"></search-service-centers>
